import { render, staticRenderFns } from "./nearby-shop-details.vue?vue&type=template&id=85baff4a&scoped=true&"
import script from "./nearby-shop-details.vue?vue&type=script&lang=js&"
export * from "./nearby-shop-details.vue?vue&type=script&lang=js&"
import style0 from "./nearby-shop-details.vue?vue&type=style&index=0&id=85baff4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85baff4a",
  null
  
)

export default component.exports